import { saveMeta } from 'communicator/store';
import { getOrgId, getSessionId } from 'communicator/store/selectors';
import fetchDeviceId from 'communicator/utils/api/device';
import { hasValidErmCookie, hasValidSsiCookie } from 'communicator/utils/cookies';
import { markEnd, markStart } from 'communicator/utils/instrumentation';
import { getThmProfilingPromise, loadThm } from 'communicator/utils/thm';

export default async function srciLoaded(): Promise<void> {
  // If user has ERM or SSI cookies, THM will have already been loaded by the merchant SDK.
  if (!hasValidErmCookie() && !hasValidSsiCookie()) {
    loadThm({
      isVisaSrci: true,
      orgId: getOrgId(),
      sessionId: getSessionId()
    });
  }

  markStart('thm_promise_await');
  // On load of Visa SRCi, we want to prefetch the deviceId for DFM to speed up idLookup
  const sessionId = await getThmProfilingPromise();
  markEnd('thm_promise_await');

  if (sessionId) {
    const thmProfileHint = await fetchDeviceId({ sessionId });
    saveMeta({ thmProfileHint });
  }
}
